import { v4 as uuidv4 } from "uuid";
import { NetworkError } from "@/interfaces/errors/networkError";

const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL ?? "";

export const sendFetchRequest = async (
  url: string,
  accessToken?: string,
  onCaptchaRequired?: () => void,
  onCaptchaRequired405?: () => void,
  token?: string
) => {
  if (url.includes(".js") || url.includes(".css") || url.includes(".html")) {
    return Promise.resolve({});
  }

  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());
  requestHeaders.append("x-api-key", process.env.NEXT_PUBLIC_BFF_API_KEY ?? "");
  if (accessToken !== undefined) {
    requestHeaders.append("Authorization", `Bearer ${accessToken}`);
    requestHeaders.append("Accept", "/");
  }

  if (token !== undefined) {
    requestHeaders.append("x-aws-waf-token", token);
  }

  return fetch(`${BACKEND_URL}${url}`, {
    method: "GET",
    headers: requestHeaders,
  })
    .then(async (response) => {
      if (response.status === 202) {
        if (onCaptchaRequired) {
          onCaptchaRequired();
        }
        throw new NetworkError(
          `Request returned status 202`,
          response.status,
          await response.json()
        );
      }
      if (response.status === 405) {
        if (onCaptchaRequired405) {
          onCaptchaRequired405();
        }
        throw new NetworkError(
          `Request returned status 202`,
          response.status,
          await response.json()
        );
      }

      if (!response.ok) {
        throw new NetworkError(
          `Request returned error ${response.status}`,
          response.status,
          await response.json()
        );
      }

      const contentType = response.headers.get("content-type");
      if (contentType?.includes("application/json")) {
        return response.json();
      }

      if (contentType?.includes("application/pdf")) {
        return response.blob();
      }

      if (response.status === 204) {
        throw new NetworkError(`${response.status}`, response.status);
      }

      return Promise.resolve({});
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
};
